import { assign } from 'xstate';

import { type GroupOrderReorderConfirmationEvent, type ReorderMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const storeGroupOrderReorderRequest: ReorderMachineAction<GroupOrderReorderConfirmationEvent> =
  assign((_args, params) => ({
    groupOrderReorderRequest: {
      event: params.reorderEvent,
      originStep: params.originStep,
    },
  }));
